/**
 * Created by fatih.kahraman on 02/04/2020.
 */
import reducerRegistry from '@comeon/reducer-registry';
import { importAda, openAdaChat } from '~/components/support/ducks/index-ada.js';
import {
	SHOW_DIALOG_BOX,
	SUPPORT_ADA_REMOVE_CUSTOM_METAFIELD,
	SUPPORT_ADA_UPDATE_CUSTOM_METAFIELD,
	SUPPORT_VIP_TAG_CV_VALUE,
	TOGGLE_SUPPORT_LOADING_STATUS
} from '~/components/support/ducks/constants.js';
import { importDixa, openDixaChat } from '~/components/support/ducks/index-dixa';

const REDUCER_NAME = 'support';

const toggleSupportLoadingStatus = loadingStatus => ({
	type: TOGGLE_SUPPORT_LOADING_STATUS,
	payload: loadingStatus
});

const setVIPChatTagCVValue = cvValue => ({
	type: SUPPORT_VIP_TAG_CV_VALUE,
	payload: cvValue
});

const resetSupportWidget = () => {
	return dispatch => {
		// resetting the Support VIP Tag value
		dispatch(setVIPChatTagCVValue(0));
	};
};

const showSupportDialogBox = (bool, callback) => {
	return async (dispatch, getState) => {
		const {
			brand: { regHeaderEnabled },
			browser: {
				is: { small }
			},
			support: { ada, dixa, supportLoading, supportLoaded }
		} = getState();

		if (ada) {
			if (!supportLoading && !supportLoaded) {
				dispatch(toggleSupportLoadingStatus({ loading: true, loaded: false }));
			}
			const { botHandle } = ada;
			const { locale } = getState().account;
			importAda(
				botHandle,
				locale.slice(0, 2),
				() => {
					dispatch(
						toggleSupportLoadingStatus({
							loading: false,
							loaded: true
						})
					);
					openAdaChat(bool, regHeaderEnabled && small);
					if (callback) {
						callback();
					}
				},
				isChatOpen => {
					dispatch({
						type: SHOW_DIALOG_BOX,
						payload: isChatOpen
					});
				}
			);
		} else if (dixa) {
			if (!supportLoading && !supportLoaded) {
				dispatch(toggleSupportLoadingStatus({ loading: true, loaded: false }));
			}
			importDixa(
				dixa.messengerToken,
				() => {
					dispatch(toggleSupportLoadingStatus({ loading: false, loaded: true }));
				},
				isChatOpen => {
					dispatch({
						type: SHOW_DIALOG_BOX,
						payload: isChatOpen
					});
				},
				() => {
					openDixaChat(bool);
				}
			);
		}
	};
};

const reducer = (state = {}, { type, payload }) => {
	switch (type) {
		case SHOW_DIALOG_BOX:
			return {
				...state,
				showDialogBox: payload
			};
		case TOGGLE_SUPPORT_LOADING_STATUS:
			return {
				...state,
				supportLoading: payload.loading,
				supportLoaded: payload.loaded
			};
		case SUPPORT_VIP_TAG_CV_VALUE:
			return {
				...state,
				supportVIPTagCVValue: payload
			};
		case SUPPORT_ADA_UPDATE_CUSTOM_METAFIELD:
			return {
				...state,
				ada: {
					...state.ada,
					customMetafields: {
						...state.ada.customMetafields,
						[payload.name]: payload.value
					}
				}
			};
		case SUPPORT_ADA_REMOVE_CUSTOM_METAFIELD:
			return {
				...state,
				ada: {
					...state.ada,
					customMetafields: {
						...state.ada.customMetafields,
						[payload.name]: ''
					}
				}
			};
		default:
			return state;
	}
};

reducerRegistry.register(REDUCER_NAME, reducer);

export default reducer;

export { showSupportDialogBox, toggleSupportLoadingStatus, setVIPChatTagCVValue, resetSupportWidget };
